export const HOME_PAGE_URL = '/calendar';
export const MIN_PASSWORD_LENGTH = 8;
